import React, { Component } from "react";
import { RouteComponentProps } from "react-router-dom";
import screenfull from "screenfull";

import { aspectRatio as ar } from "../../../../common/parameters";
import routing from "../../../routing";

import Frame from "../Frame";

import { StyledWrapper } from "./styles";
import { IProps } from "./interfaces";

class Wrapper extends Component<RouteComponentProps & IProps> {
    state = { scale: 0.1, fullscreen: false };
    isPlaying = false;
    isLanding?: boolean
    isSimulation?: boolean
    timer?: ReturnType<typeof setTimeout>
    ref?: HTMLDivElement;
    fullScreen = () => {
        if (screenfull) {
            if (this.state.fullscreen) {
                screenfull.exit();
            } else {
                screenfull.request();
            }
        }
    };
    componentDidMount() {
        const { pathname } = this.props.history.location;
        this.isLanding = this.props.history.location.pathname === "/";
        this.isPlaying =
            (pathname.slice(1, routing.play.length + 1) === routing.play ||
            pathname.slice(1, routing.share.length + 1) === routing.share ||
            pathname.slice(1, routing.publicPlay.length + 1) === routing.publicPlay ||
            pathname.slice(1, routing.homework.length + 1) === routing.homework ||
            pathname.slice(1, routing.join.length + 1) === routing.join
            ) && !this.props.isExperienceCenter;
        const distanceTeachingRoute = `${routing.help}/distance-teaching`;
        this.isSimulation =
            pathname.slice(1, distanceTeachingRoute.length + 1) === distanceTeachingRoute;
        this.resizeHandler();
        if (screenfull && screenfull.enabled) {
            screenfull.on("change", () => {
                if (screenfull) {
                    this.setState({ fullscreen: screenfull.isFullscreen })
                }
            });
        }
        window.addEventListener("resize", this.resize);
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
        clearTimeout(this.timer);
    }
    resize = () => {
        clearTimeout(this.timer);
        setTimeout(() => {
            this.resizeHandler();
        });
        this.timer = setTimeout(this.resizeHandler, 500);
    };
    resizeHandler = () => {
        if ((!this.isPlaying || this.isLanding || this.props.isDemo || this.props.isExperienceCenter) && !this.isSimulation) {
            let diminishHeight = 0;
            if (this.props.history.location.pathname.indexOf("/" + routing.tasks) !== -1 && window.innerWidth < 992) {
                diminishHeight += 104;
                if (window.innerWidth <= 550) {
                    diminishHeight += 48;
                }
            }
            let editorMaxWidth =
                (window.innerHeight - (this.isLanding ? 80 : 196) - diminishHeight) * (ar.width / ar.height);
            if (this.props.history.location.pathname === "/" || this.props.isDemo) editorMaxWidth = 10000;
            let parentWidth = Math.min((this.ref!.parentNode as HTMLDivElement).getBoundingClientRect().width, editorMaxWidth);
            if (this.props.isDemo) parentWidth = (this.ref!.parentNode!.parentNode as HTMLDivElement).getBoundingClientRect().width;
            this.setState({ scale: parentWidth / ar.width });
            return;
        }
        let w = window.innerWidth;
        let h = window.innerHeight;
        if (this.isPlaying) {
            h -= 50;
        }
        let scale;
        if (w / h < ar.width / ar.height) {
            // magasabb
            scale = w / ar.width;
        } else {
            //szélesebb
            scale = h / ar.height;
        }
        if (this.isSimulation) {
            if (window.innerWidth > 768) {
                scale = ar.height / ar.width;
            } else {
                const mobileWidth = window.innerWidth - 32;
                scale = mobileWidth / ar.width;
            }
        }
        this.setState({ scale });
    };
    render() {
        const { scale } = this.state;
        const { history, isFlow, contextScale } = this.props;
        const isExperience = history.location.pathname.indexOf(routing.experience) !== -1 || (process.env.WEBPACK && window.homeworkAsExperience);
        return (
            <StyledWrapper
                ref={ref => {
                    if (!this.ref && ref) {
                        this.ref = ref;
                        this.forceUpdate();
                    }
                }}
                style={{
                    width: ar.width * scale / (contextScale || 1),
                    height: ar.height * scale / (contextScale || 1),
                }}
            >
                {this.ref !== undefined && (
                    <Frame
                        parent={this.ref}
                        backgroundColor={isExperience ? "transparent" : "#ecf5f4"}
                        transparent={!!isExperience}
                        isFlow={isFlow}
                        isExperience={!!isExperience}
                        contextScale={contextScale}
                    >
                        {this.props.children}
                    </Frame>
                )}
            </StyledWrapper>
        );
    }
}

export default Wrapper;
